export default {
  installation: store => store.installation || {},
  userAccessibleInstallations: store => store.userAccessibleInstallations || [],
  isUserAccessibleInstallationsLoaded: store => store.userAccessibleInstallations != null,
  simulationData: store => store.simulationData || {},
};
